<div class="partner-page">
    <section class="partner-hero animate-fade-in-up" aria-label="Partner Program">
        <div class="partner-hero__container">
            <div class="partner-hero__head">
                <div class="partner-hero__eyebrow">Global Network</div>
                <div class="partner-hero__title">Partner Program.</div>
                <div class="partner-hero__copy">
                    Join forces with a leading Applied AI company. Earn highly competitive commissions, access exclusive
                    architectural resources, and co-build the future of enterprise intelligence alongside us.
                </div>
            </div>

            <div class="partner-tiers">
                <article class="partner-tier">
                    <div class="partner-tier__title">Reseller Partnership</div>
                    <div class="partner-tier__value">20%</div>
                    <div class="partner-tier__label">Commission Tier</div>
                </article>
                <article class="partner-tier">
                    <div class="partner-tier__title">Referral Partnership</div>
                    <div class="partner-tier__value partner-tier__value--light">10%</div>
                    <div class="partner-tier__label">Commission Tier</div>
                </article>
            </div>

            <div class="partner-process">
                <div class="partner-process__title">The Integration Process</div>
                <div class="partner-process__grid">
                    <article class="partner-step">
                        <div class="partner-step__phase">Phase 01</div>
                        <div class="partner-step__title">Apply & Qualify</div>
                        <div class="partner-step__copy">
                            Submit your application to join the ecosystem. Share your core business details, regional
                            reach, and strategic expertise.
                        </div>
                    </article>

                    <article class="partner-step">
                        <div class="partner-step__phase">Phase 02</div>
                        <div class="partner-step__title">Onboard & Train</div>
                        <div class="partner-step__copy">
                            Access exclusive engineering resources, deep architectural training, extensive marketing
                            materials, and our dedicated partner portal.
                        </div>
                    </article>

                    <article class="partner-step">
                        <div class="partner-step__phase">Phase 03</div>
                        <div class="partner-step__title">Promote & Profit</div>
                        <div class="partner-step__copy">
                            Promote Reve methodologies within your network and earn substantial structural commissions
                            for every successful enterprise deal.
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>

    <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
        <div class="contact-section__container">
            <div class="contact-section__grid">
                <div>
                    <div class="contact-section__eyebrow">Connect</div>
                    <div class="contact-section__title">Discover the future of applied AI.</div>
                    <div class="contact-section__copy">
                        Connect with our delivery experts to audit your topology and map your enterprise integration
                        roadmap.
                    </div>
                </div>

                <div class="contact-card">
                    <div class="contact-card__corner" aria-hidden="true"></div>
                    <div class="contact-card__title">Direct Inquiry</div>

                    <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <div>Request securely logged. Our architecture team will reach out within one business day.
                        </div>
                    </div>

                    <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
                        <div class="contact-form__field">
                            <input type="text" formControlName="name" placeholder="Full Name" />
                        </div>

                        <div class="contact-form__row">
                            <div class="contact-form__field">
                                <input type="email" formControlName="email" placeholder="Corporate Email" />
                            </div>
                            <div class="contact-form__field">
                                <input type="text" formControlName="company" placeholder="Organization" />
                            </div>
                        </div>

                        <div class="contact-form__field">
                            <textarea rows="3" formControlName="message"
                                placeholder="Brief context of operational challenges..."></textarea>
                        </div>

                        <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
                            class="contact-form__submit">
                            <span *ngIf="!isSubmitting">Transmit Request</span>
                            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                                Encrypting...
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section> -->
</div>